import {
  breakpointSizes,
  Button,
  ButtonDesigns,
  ButtonTypes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import InsetOption from 'src/components/InsetOption/InsetOption'
import Trns from 'src/localization/Trns'
import { BankAccountListModel } from 'src/models/bankAccount.models'
import { css } from 'styled-components'

interface DisconnectOrgIntegrationViewProps {
  disconnectAccount: () => void
  loading?: boolean
  bankAccount?: BankAccountListModel
  connectedPlatformName: string
}

const DisconnectOrgIntegrationView: React.FC<
  DisconnectOrgIntegrationViewProps
> = (props): React.ReactElement => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        padding: 50px 60px;

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          padding: 40px;
        `)};
      `}
    >
      <span
        css={css`
          margin-bottom: 12px;
          ${getFontCss(
            20,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns
          source={'${connectedPlatform} Account'}
          expressions={{
            connectedPlatform: props.connectedPlatformName,
          }}
        />
      </span>
      <p
        css={css`
          margin-bottom: 12px;
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        <Trns
          source={
            'To connect to another ${connectedPlatform} Account, you need to disconnect from ${connectedPlatform} and start the process again'
          }
          expressions={{
            connectedPlatform: props.connectedPlatformName,
          }}
        />
      </p>
      <InsetOption
        css={css`
          display: flex;
          align-items: center;
          align-self: stretch;
          margin-bottom: 20px;
          justify-content: space-between;
        `}
      >
        <span
          css={css`
            display: flex;
            align-items: center;
            ${getFontCss(
              16,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          {props.bankAccount?.accountName}
        </span>
        <Button
          onClick={props.disconnectAccount}
          type={ButtonTypes.button}
          design={ButtonDesigns.designRed}
          text={<Trns source={'Disconnect'} />}
          big
        />
      </InsetOption>
    </div>
  )
}

export default DisconnectOrgIntegrationView
